import React from 'react';
import { useSelector } from 'react-redux';
import GlobalLoader from '../components/Loader';

export const GlobalLoaderContainer = () => {
  const isLoading = useSelector(({ loader }) => loader.isLoading);
  const type = useSelector(({ loader }) => loader.type);
  const isNetworkLoader = type === 'network-check';

  if (!isLoading) return null;

  return <GlobalLoader isNetworkLoader={isNetworkLoader} />;
};

export default GlobalLoaderContainer;
